import React, { useState } from "react";
import { navigate } from "gatsby";
import { ArrowIcon, Container } from "./styles";
import Title from "../Title";
import arrowIcon from "../../images/arrow_icon.svg";
import { appUrl } from "../../utils/appUrl";
import { useSegment } from "../../utils/SegmentContext";

const LicenseCard = ({
  title,
  highlightContent,
  fullContent,
  number,
  background,
  isMobile,
  subscribe,
}) => {
  const segmentId = useSegment();
  const [isCollapsed, toggleCollapsed] = useState(false);

  const mainContent = (
    <>
      <p className="detail-text">{highlightContent}</p>
      {isCollapsed && <div>{fullContent}</div>}
      <div className="button-container">
        {subscribe && (
          <button
            onClick={() => {
              window.location = appUrl("/subscription", segmentId);
            }}
            className="subscribe-button"
          >
            Subscribe Now
          </button>
        )}
        <button
          className="license-button"
          onClick={() => {
            toggleCollapsed(!isCollapsed);
            navigate(`/licensing/#${title.toLowerCase().replace(" ", "_")}`);
          }}
        >
          <ArrowIcon
            isCollapsed={isCollapsed}
            src={arrowIcon}
            className="arrow-icon"
            alt="arrow-icon"
          />
          {!isCollapsed ? "More info" : "Collapse"}
        </button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <Container
        id={title.toLowerCase().replace(" ", "_")}
        className="mobile-container"
        background={background}
      >
        <div className="mobile-card-header">
          <div className="number">
            <p>{number}</p>
          </div>
          <Title className="title" title={title} />
        </div>
        {mainContent}
      </Container>
    );
  }

  return (
    <Container
      background={background}
      id={title.toLowerCase().replace(" ", "_")}
    >
      <div className="number">
        <p>{number}</p>
      </div>
      <div className="content">
        <Title className="title" title={title} />
        {mainContent}
      </div>
    </Container>
  );
};

export default LicenseCard;
